const preparedSiteReference = (value: string) => value.trim().toUpperCase();

export const isValidSiteReference = (value: string) =>
    /^(?:[A-Z]{2}-\d{2}-[A-Z]-\d{2}|[A-Z]{2}\d{2}[A-Z]\d{2})$/.test(preparedSiteReference(value));

export const normaliseSiteReference = (value: string) => {
    const prepared = preparedSiteReference(value);
    if (!isValidSiteReference(prepared))
        return prepared;

    const compact = prepared.replace(/-/g, '');
    return `${compact.slice(0, 2)}-${compact.slice(2, 4)}-${compact.slice(4, 5)}-${compact.slice(5, 7)}`;
};

export const siteReferenceHelperText = 'Use AA-01-A-01 or AA01A01.';
